import { render, staticRenderFns } from "./PropertyIndex.vue?vue&type=template&id=65302c30"
import script from "./PropertyIndex.vue?vue&type=script&lang=js"
export * from "./PropertyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports